import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const DemoTag = () => {
  const { t } = useTranslation();

  return <span className={styles.demoTag}>{t('demoMode.tag')}</span>;
};

export default DemoTag;
